import { COLORS } from "../../utils/js/constants";

export const menuDashStyle = (theme) => {

    const drawerWidth = 240;

    return {
        drawerPaper: {
            position: "relative",
            whiteSpace: "nowrap",
            width: drawerWidth,
            backgroundColor: COLORS.grey,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerPaperClose: {
            overflowX: "hidden",
            width: theme.spacing(7),
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            [theme.breakpoints.up("sm")]: {
                width: theme.spacing(9),
            },
        },
        iconColor: {
            color: COLORS.yellow 
        },
        itemMenuColor: {
            color: COLORS.white
        },
        toolbarIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0 8px",
            ...theme.mixins.toolbar,
        },
        activeIcon: {
            color: COLORS.primary
        },
        navLink: {
            display: "flex",
            color: COLORS.lightYellow,
            textDecoration: 'none'
        }
    }
}

